module.exports = __webpack_public_path__ + "gu.svg?d4375e9d037d29bc430f6b8f2591514e";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/gu.svg
// module id = 1393
// module chunks = 0